import { forwardRef, HTMLAttributes } from "react"
import { callCSSFn, CSSFn, styled, StyleProps } from "../styles"

type LinkOwnProps = {
  css?: CSSFn
}

export type LinkProps = LinkOwnProps & React.ComponentPropsWithRef<typeof StyledLink>

const Link: React.FC<LinkProps> = forwardRef((props, forwardedRef) => <StyledLink ref={forwardedRef} {...props} />)

Link.displayName = `Link`

export { Link }

const linkCss = (props: StyleProps) => ({
  color: props.theme.palette.link,
  textDecoration: `underline`,
  "&:hover": {
    cursor: `pointer`,
  },
  ...callCSSFn(props),
})

const StyledLink = styled.a<HTMLAttributes<HTMLLinkElement>>((props: StyleProps) => linkCss(props))
export const DivStyledAsLink = styled.div<HTMLAttributes<HTMLDivElement>>((props: StyleProps) => linkCss(props))
